import React, {Component} from 'react';
import {connect} from "react-redux";
import Objects from "../../redux/Objects";

class NoConnection extends Component {

    render() {
        return this.props.connectionError ?
            (<div className="connection-error">
                <div className="hv-container four-fifth d-flex flex-column justify-content-center">
                    <div className="icon-reload s4-x" />
                    <div className="message"><span>You are not connected to internet</span></div>
                    <div className="message little">
                        <a href="/hom">Try again</a>
                    </div>
                </div>
            </div>) : (<div/>)
    }
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

const mapStateToProps = (state) => {
    return {
        connectionError: state.param[Objects.connectionError]
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NoConnection)
